import lodash from 'lodash';
import React, { useCallback } from 'react';
import { Field, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { useHistory } from 'react-router-dom';
import { FormGroup } from 'reactstrap';
import * as Yup from 'yup';

import { loginUserSuccessPartner } from 'redux/auth/authActions';
import { PartnerUserImpersonationAutosuggest, SubmitButton } from 'ui-blocks/form-elements';
import { impersonateAsPartnerUser } from 'app/services/partnerImpersonationService';

const validationSchema = Yup
   .object()
   .shape({
      user: Yup.object().shape({
         userId: Yup.number().required('Required!'),
      })
         .nullable()
         .required('Please select a value from the autosuggest.'),
   });

const PartnerImpersonationForm = (props) => {
   const dispatch = useDispatch();
   const history = useHistory();

   const handleSubmit = useCallback((values, formikBag) => {
      const valuesCopy = lodash.cloneDeep(values);
      impersonateAsPartnerUser(valuesCopy?.user?.userId).then(({ data }) => {
         formikBag.setSubmitting(false);
         if (data?.token && !(data?.error)) {
            dispatch(loginUserSuccessPartner({
               token: data.token,
            }));
            history.push('/partner/impersonation');
         } else {
            toastr.error(`An error occurred. Please try again later.`);
         }
      });
   }, []);

   return (
      <Formik
         initialValues={ {} }
         validationSchema={ validationSchema }
         validateOnChange={ false }
         validateOnBlur={ false }
         onSubmit={ handleSubmit }
      >
         {
            (formik) => (
               <Form>
                  <FormGroup>
                     <label>
                        Organization/Account
                     </label>
                     <Field
                        name='user'
                        component={ PartnerUserImpersonationAutosuggest }
                     />
                  </FormGroup>
                  <div className='text-center mt-3'>
                     <SubmitButton
                        isLoading={formik.isSubmitting}
                     />
                  </div>
               </Form>
            )
         }
      </Formik>
   );
};

export default PartnerImpersonationForm;
